import React, { createRef } from "react";
import { withStyles } from "@material-ui/core/styles";
import DrawerComp from "./subComponents/drawerComp";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { removeXSSAttacks } from "../common/helper";
import ConsultTab from "./consultTab";
import Notes from "./notes";
import DenyAndEmail from "./subComponents/denyAndSendEmail";
import ApproveAndSendEmail from "./subComponents/approveAndSendEmail";
import SendOrderToCSComponent from "./subComponents/sendOrderToCS";
import AddNote from "./subComponents/addNote";
import AddSoapNote from "./subComponents/addSoapNote";
import Email from "./email";
import History from "./history";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import StartVisit from "./subComponents/startVisit";
import Tooltip from "./subComponents/toolTip";
import WarningIcon from "@material-ui/icons/Warning";
import MainPageStyle from "../styles/mainPageStyle";
import callPatientIcon from "../assets/callPatient.svg";
import textPatientIcon from "../assets/textPatient.svg";
import CallPatient from "./subComponents/callPatient";
import TextPatient from "./subComponents/textPatient";
import DoneIcon from "@material-ui/icons/Done";
import EmailPatient from "./subComponents/emailPatient";
import DoseSpotErrorModal from "./subComponents/doseSpotErrorModal";
import PPButton from './subComponents/button';
import { PatientChartControllerHOC } from '../controllers/patientChart';
import { Uploads } from './patientChart';

const approveAndSendEmailButtonRef = createRef();
const denyAndSendEmailButtonRef = createRef();
const sendOrderToCsButtonRef = createRef();
const addSoapNoteRef = createRef();
const addNoteRef = createRef();
const emailPatientRef = createRef();
const callPatientRef = createRef();

const ControlledUploads = PatientChartControllerHOC(Uploads);

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const withMediaQuery =
  (...args) =>
  (Component) =>
  (props) => {
    const mediaQuery = useMediaQuery(...args);
    return <Component mediaQuery={mediaQuery} {...props} />;
  };

class MainPage extends React.Component {
  state = {
    isDrawerOpen: false,
    addNote: false,
    openEmailPatient: false,
    AddSoapNote: false,
    disableWithoutSoap: true
  };

  componentDidMount() {
    const { GetSoapNoteInfo = () => {}, selectedCardData, soapNoteInfo } = this.props;
    const { OrderId } = selectedCardData;
    GetSoapNoteInfo({ OrderId });
    this.setState({
      disableWithoutSoap: !soapNoteInfo
    });
  }

  enableOnSoapSuccess = () =>{
    this.setState({
      disableWithoutSoap: false
    });
  }
  
  componentDidUpdate(prevProps) {
    const { GetSoapNoteInfo = () => {}, selectedCardData, soapNoteInfo, selectedPatientInfo: patient, GetPatientUploads = () => {} } = this.props;
    const { OrderId } = selectedCardData;
    const { api: patientAPI = {}, UserId } = patient;

    if (OrderId !== prevProps.selectedCardData.OrderId || soapNoteInfo !== prevProps.soapNoteInfo) {
      GetSoapNoteInfo({ OrderId });
      this.setState({
        disableWithoutSoap: !soapNoteInfo
      });
    }

    const hasPatientInfo = patientAPI.called && !patientAPI.loading && UserId;
    const hasDifferentPatientInfo = prevProps.selectedPatientInfo.UserId !== UserId;
    if (hasPatientInfo && hasDifferentPatientInfo) {
      GetPatientUploads({ UserId });
    }
 
    const {
      approveAndEmailDone,
      denyAndEmailDone,
      sendOrderToCSDone,
      handleRouteChange,
      isDoseSpotError,
      callStarted = false
    } = this.props;

    if (
      prevProps.callStarted &&
      !callStarted &&
      (sendOrderToCSDone ||
        approveAndEmailDone ||
        denyAndEmailDone ||
        isDoseSpotError)
    ) {
      handleRouteChange && handleRouteChange(void 0, 0);
    }
  }

  changeValueToString = (data) => {
    let response = "";
    data &&
      data.length !== 0 &&
      data.forEach((value, index) => {
        if (index === 0) {
          response = value;
        } else {
          response = response + ", " + value;
        }
      });
    if (!response) {
      response = "NONE";
    }
    return response;
  };

  handleChange = (event, index) => {
    let { SetSelectedTab } = this.props;
    SetSelectedTab && SetSelectedTab(index);
  };

  closeDoseSpotErrorModal = () => {
    let { handleRouteChange, callStarted, HandleGlobalValueChange } =
      this.props;
    HandleGlobalValueChange &&
      HandleGlobalValueChange({
        value: false,
        name: 'isDoseSpotErrorModalOpen',
      });
    if (!callStarted) {
      handleRouteChange && handleRouteChange(void 0, 0);
    }
  };

  render() {
    let {
      classes,
      data,
      selectedPatientInfo = {},
      selectedTab,
      handleRouteChange,
      selectedCardData,
      title,
      routePath,
      notes,
      sendOrderToCSNote,
      GetEmailTemplate,
      GetEmailTemplateFromSalesforce,
      GetSubjectAndMailFromSalesforce,
      GetDenialReasons,
      GetSendOrderToCSReasons,
      sendOrderToCSReasons,
      SendOrderToCS,
      emailTemplate,
      isSearchType,
      GetApproveAndEmailPrepInfo,
      approveAndMailData,
      mediaQuery,
      callStarted,
      SetStartVisit,
      ResetSendOrderToCS,
      SetSendOrderToCSData,
      sendOrderToCSReason,
      callPatientDetails,
      GetCallPatientDetails,
      SetCallPatientDetails,
      ResetCallPatientDetails,
      CallToPatient,
      CallToPatientPhys,
      callToPatientStatus,
      isModalTwilioAlertOpen,
      EmailPatientDetails,
      SetModalTwilioAlertOpen,
      isEmailSentToPatient,
      GetTextPatientTemplates,
      textMessageTemplateValue,
      textmessageTemplateData,
      openTextPatient,
      ResetTextPatientDetails,
      isNoteAdded,
      approveAndSendEmailOpen,
      approveAndEmailDone,
      denyAndEmailDone,
      denyAndEmailOpen,
      sendOrderToCSOpen,
      sendOrderToCSDone,
      isVideoFocused,
      CallDetails,
      callDetailSent,
      CallEnd,
      doseSpotData,
      ApproveAndMailSubmit,
      LogError,
      isDoseSpotError,
      isDoseSpotErrorModalOpen,
      addSoapNoteOpen,
      addNoteOpen,
      emailPatientOpen,
      callPatientOpen,
      OrderCallSummaryReasons,
      SetCallSummary,
      InsertCallSummary,
      getCmnPdfData,
      soapNoteTemplates,
      patientUploads,
      SetSoapNoteTemplate: setSoapTemplate = () => {},
      GetSoapNoteTemplates: getSoapTemplates = () => {},
      ...restProps
    } = this.props;

    const IsDoctorNotConfiguredWithDosespot =
      (!restProps.loading &&
        !selectedPatientInfo.IsDoctorConfiguredWithDosespot) ||
      (restProps.loading &&
        selectedPatientInfo.IsDoctorConfiguredWithDosespot === false);
    return (
      <div className={classes.wrapper} data-view="scheduledVisitsPage">
        <DrawerComp
          routePath={routePath}
          title={title}
          callStarted={callStarted}
          selectedCardData={selectedCardData}
          drawerValue={(_) => this.setState({ isDrawerOpen: _ })}
          handleRouteChange={handleRouteChange}
          data={data}
          isSearchType={isSearchType}
          selectedPatientInfo={selectedPatientInfo}
        />
        <div className={classes.contentWrapper} data-view="patientDemographics">
          <div
            className={`${classes.headerSection} ${
              !this.state.isDrawerOpen ? classes.headerToggleStyle : ""
            }`}
          >
            <div className={classes.demographics}>
              <div id="main-page-patient-name" className={classes.patientName}>
                {selectedPatientInfo.FirstName} {selectedPatientInfo.LastName}
              </div>
              <div className={classes.patientDOBContainer}>
                <div
                  id="main-page-patient-region"
                  className={classes.patientRegion}
                >
                  {selectedPatientInfo.City
                    ? selectedPatientInfo.City + ", "
                    : ""}
                  {selectedPatientInfo.State}
                </div>
                <div
                  id="main-page-patient-dob"
                  className={classes.patientRegion}
                >
                  DOB: {selectedPatientInfo.DOB ? selectedPatientInfo.DOB : ""}
                </div>
              </div>
              <div
                id="main-page-patient-gender"
                className={classes.patientGender}
              >
                Gender Identity: {selectedPatientInfo.Gender}
              </div>
              <div
                id="main-page-storefront-name"
                className={classes.storefrontName}
              >
                {(restProps.productInfo &&
                  restProps.productInfo.StoreFrontURL) ||
                  ""}
              </div>
              <div className={classes.hyperlink}>     
                  <div
                    ref="callPatientRef"
                    id="main-page-patient-call-patient"
                    className={classes.patientIcon}
                    onClick={() => {
                      callPatientRef &&
                        callPatientRef.current &&
                        callPatientRef.current.blur();
                      restProps.HandleGlobalValueChange({
                        value: true,
                        type: 'commonModal',
                        name: 'callPatientOpen',
                      });
                    }}
                  >
                    <img
                      id="main-page-patient-call-patient-icon"
                      src={callPatientIcon}
                      alt=""
                    />
                    <label
                      id="main-page-patient-call-patient-label"
                      className={`${classes.patientIconText}`}
                    >
                      Call Patient
                    </label>
                  </div>
                  <div
                    className={classes.patientIcon}
                    onClick={() =>
                      restProps.HandleGlobalValueChange({
                        value: true,
                        type: 'commonModal',
                        name: 'openTextPatient',
                      })
                    }
                  >
                    <img
                      src={textPatientIcon}
                      id="main-page-patient-text-icon"
                      alt=""
                    />
                    <label
                      id="main-page-patient-text-label"
                      className={`${classes.patientIconText}`}
                    >
                      Text Patient
                    </label>
                  </div>
              </div>
            </div>
            <div className={classes.statsWrapper}>
              <div className={classes.stats}>
                <div className={classes.statsDetails}>
                  <div className={classes.textCenter}>
                    <div
                      id="main-page-patient-weight-value"
                      className={classes.patientStats}
                    >
                      {selectedPatientInfo.Weight
                        ? selectedPatientInfo.Weight + " lb"
                        : "-"}
                    </div>
                    <div
                      id="main-page-patient-weight-label"
                      className={classes.patientStatsTitle}
                    >
                      Weight
                    </div>
                  </div>
                  <div className={classes.textCenter}>
                    <div
                      id="main-page-patient-height-value"
                      className={classes.patientStats}
                    >
                      {selectedPatientInfo.Height
                        ? selectedPatientInfo.Height + '"'
                        : "-"}
                    </div>
                    <div
                      id="main-page-patient-height-label"
                      className={classes.patientStatsTitle}
                    >
                      Height
                    </div>
                  </div>
                  <div className={classes.textCenter}>
                    <div
                      id="main-page-patient-bmi-value"
                      className={classes.patientStats}
                    >
                      {selectedPatientInfo.BMI ? selectedPatientInfo.BMI : "-"}
                    </div>
                    <div
                      id="main-page-patient-bmi-label"
                      className={classes.patientStatsTitle}
                    >
                      BMI
                    </div>
                  </div>
                  <div className={classes.textCenter}>
                    <div
                      id="main-page-patient-age-value"
                      className={classes.patientStats}
                    >
                      {selectedPatientInfo.Age ? selectedPatientInfo.Age : "-"}
                    </div>
                    <div
                      id="main-page-patient-age-label"
                      className={classes.patientStatsTitle}
                    >
                      Age
                    </div>
                  </div>
                  {routePath === "pendingFilesCard" || isSearchType ? (
                    <div className={classes.dummyVisitButton} />
                  ) : (
                    <div>
                      <StartVisit
                        isVideoFocused={isVideoFocused}
                        LogError={LogError}
                        callStarted={callStarted}
                        CallDetails={CallDetails}
                        callDetailSent={callDetailSent}
                        CallEnd={CallEnd}
                        SetStartVisit={SetStartVisit}
                        GetTokenAndStartVist={restProps.GetTokenAndStartVist}
                        loading={restProps.loading} // how is loading populated
                        selectedCardData={selectedCardData}
                        selectedPrescriberInfo={restProps.selectedPrescriberInfo}
                        getOrderNotes={restProps.GetOrderNotes}
                        getPatientNotes={restProps.GetPatientNotes}
                        getMedicalOrderNotes={restProps.GetMedicalOrderNotes}
                        getMedicalPatientNotes={restProps.GetMedicalPatientNotes}
                      />
                    </div>
                  )}
                </div>
              </div>

              <div className={classes.medWrapper}>
                <div
                  id="main-page-patient-sf-medication-wrapper"
                  className={classes.storefrontMedication}
                >
                  <span
                    id="main-page-patient-sf-medication-label"
                    className={classes.medBold}
                  >
                    Storefront Medications:
                  </span>{" "}
                  {this.changeValueToString(
                    selectedPatientInfo.StorefrontMedications
                  )}
                </div>
                <div
                  id="main-page-patient-personal-medication-wrapper"
                  className={`${classes.storefrontMedication} ${classes.storefrontMedicationMargin}`}
                >
                  <span
                    id="main-page-patient-personal-medication-label"
                    className={classes.medBold}
                  >
                    Personal Medications:
                  </span>{" "}
                  {this.changeValueToString(
                    selectedPatientInfo.PersonalMedicatoins
                  )}
                </div>
                <div
                  id="main-page-patient-seriour-illness"
                  className={`${classes.storefrontMedication} ${classes.storefrontMedicationMargin}`}
                >
                  <span
                    id="main-page-patient-serious-illness-label"
                    className={classes.medBold}
                  >
                    Serious Illness:
                  </span>{" "}
                  {this.changeValueToString(selectedPatientInfo.SeriousIllness)}
                </div>
                <div
                  id="main-page-patient-allergies"
                  className={`${classes.storefrontMedication} ${classes.storefrontMedicationMargin}`}
                >
                  <span
                    id="main-page-patient-allergies-label"
                    className={classes.medBold}
                  >
                    Allergies:
                  </span>{" "}
                  {this.changeValueToString(selectedPatientInfo.Allergies)}
                </div>
                <div className={classes.actionWrapper}>
                  {IsDoctorNotConfiguredWithDosespot ? (
                    <Tooltip
                      placement="right"
                      title="DoseSpot setup is required. Tech support will notify you when ready for Approval."
                    >
                      <WarningIcon className={classes.doseSpotWarning} />
                    </Tooltip>
                  ) : null}
                  <div className={classes.actionParent}>
                    <PPButton
                      id='approveAndEmail'
                      reference={approveAndSendEmailButtonRef}
                      label='Approve'
                      onClick={() => {
                        approveAndSendEmailButtonRef &&
                          approveAndSendEmailButtonRef.current &&
                          approveAndSendEmailButtonRef.current.blur();
                        restProps.HandleGlobalValueChange({
                          value: true,
                          type: 'commonModal',
                          name: 'approveAndSendEmailOpen',
                        });
                      }}
                      disabled={
                        IsDoctorNotConfiguredWithDosespot ||
                        approveAndEmailDone ||
                        denyAndEmailDone ||
                        sendOrderToCSDone ||
                        isDoseSpotError ||
                        isSearchType ||
                        this.state.disableWithoutSoap
                      }
                      endIcon={approveAndEmailDone && (
                        <DoneIcon className={classes.doneIcon} />
                      )}
                      endGutter
                    />
                    <PPButton
                      id='denyAndEmailButton'
                      reference={denyAndSendEmailButtonRef}
                      label='Deny'
                      onClick={() => {
                        denyAndSendEmailButtonRef &&
                          denyAndSendEmailButtonRef.current &&
                          denyAndSendEmailButtonRef.current.blur();
                        restProps.HandleGlobalValueChange({
                          value: true,
                          type: 'commonModal',
                          name: 'denyAndEmailOpen',
                        });
                      }}
                      disabled={
                        approveAndEmailDone ||
                        denyAndEmailDone ||
                        sendOrderToCSDone ||
                        isSearchType ||
                        this.state.disableWithoutSoap
                      }
                      endIcon={denyAndEmailDone && (
                        <DoneIcon className={classes.doneIcon} />
                      )}
                      endGutter
                    />
                    <PPButton
                      id="addSoapNote"
                      reference={addSoapNoteRef}
                      onClick={() => {
                        addSoapNoteRef &&
                          addSoapNoteRef.current &&
                          addSoapNoteRef.current.blur();
                        restProps.HandleGlobalValueChange({
                          value: true,
                          type: 'commonModal',
                          name: 'addSoapNoteOpen',
                        });
                      }}
                      disabled={isSearchType}
                      label='SOAP Note'
                      endGutter
                    />
                    <PPButton
                      id='addNote'
                      reference={addNoteRef}
                      onClick={() => {
                        addNoteRef &&
                          addNoteRef.current &&
                          addNoteRef.current.blur();
                        restProps.HandleGlobalValueChange({
                          value: true,
                          type: 'commonModal',
                          name: 'addNoteOpen',
                        });
                      }}
                      label='Add Note'
                      endGutter
                    />
                    <PPButton
                      id='emailPatient'
                      reference={emailPatientRef}
                      onClick={() => {
                        emailPatientRef &&
                          emailPatientRef.current &&
                          emailPatientRef.current.blur();
                        restProps.HandleGlobalValueChange({
                          value: true,
                          type: 'commonModal',
                          name: 'emailPatientOpen',
                        });
                      }}
                      label='Email'
                      endGutter
                    />
                    <PPButton
                      id='sendOrderToCS'
                      reference={sendOrderToCsButtonRef}
                      onClick={() => {
                        sendOrderToCsButtonRef &&
                          sendOrderToCsButtonRef.current &&
                          sendOrderToCsButtonRef.current.blur();
                        restProps.HandleGlobalValueChange({
                          value: true,
                          type: 'commonModal',
                          name: 'sendOrderToCSOpen',
                        });
                      }}
                      disabled={
                        approveAndEmailDone ||
                        denyAndEmailDone ||
                        sendOrderToCSDone ||
                        isSearchType
                      }
                      label='Send To Support'
                      endIcon={sendOrderToCSDone && (
                        <DoneIcon
                          className={`${classes.doneIcon} ${classes.lastDoneIcon}`}
                        />
                      )}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className={classes.criticalNoteWrapper}>
            {notes &&
              notes.map((_, index) => {
                return (
                  <div
                    id="doctor-notes"
                    className={`${classes.criticalNoteWrapperRow} ${
                      !_.Required ? classes.criticalNoteNotRequired : ""
                    } ${
                      index % 2 !== 0 ? classes.criticalNoteWrapperEvenRow : ""
                    }`}
                    dangerouslySetInnerHTML={{
                      __html: removeXSSAttacks(_.NoteText),
                    }}
                  ></div>
                );
              })}
          </div>

          {
            !!(restProps.productInfo && restProps.productInfo.OrderId) && (
              <>
                <div className={classes.tabHeader}>
                  <Tabs
                    TabIndicatorProps={{ children: <div /> }}
                    classes={{ indicator: classes.indicator, root: classes.tabsRoot }}
                    value={selectedTab}
                    onChange={this.handleChange}
                    aria-label="simple tabs example"
                  >
                    <Tab
                      id="home-consult-tab"
                      classes={{
                        root:
                          selectedTab === 0 ? classes.selectedTab : classes.tabStyle,
                      }}
                      label="Consult"
                      {...a11yProps(0)}
                    />
                    <Tab
                      id="home-notes-tab"
                      classes={{
                        root:
                          selectedTab === 1 ? classes.selectedTab : classes.tabStyle,
                      }}
                      label="Notes"
                      {...a11yProps(1)}
                    />
                    <Tab
                      id="home-email-tab"
                      classes={{
                        root:
                          selectedTab === 2 ? classes.selectedTab : classes.tabStyle,
                      }}
                      label="Email"
                      {...a11yProps(2)}
                    />
                    <Tab
                      id="home-history-tab"
                      classes={{
                        root:
                          selectedTab === 3 ? classes.selectedTab : classes.tabStyle,
                      }}
                      label="History"
                      {...a11yProps(3)}
                    />
                    <Tab
                      id="home-uploads-tab"
                      classes={{
                        root:
                          selectedTab === 4 ? classes.selectedTab : classes.tabStyle,
                      }}
                      label="Uploads"
                      {...a11yProps(4)}
                    />
                  </Tabs>
                </div>
                <TabPanel id="home-consult-tab-panel" value={selectedTab} index={0}>
                  <ConsultTab
                    routePath={routePath}
                    isEditDisabled={
                      approveAndEmailDone ||
                      denyAndEmailDone ||
                      sendOrderToCSDone ||
                      isSearchType
                    }
                    selectedCardData={selectedCardData}
                    selectedPatientInfo={selectedPatientInfo}
                    {...restProps}
                    isHistoryView={false}
                  />
                </TabPanel>
                <TabPanel id="home-notes-tab-panel" value={selectedTab} index={1}>
                  <Notes
                    isEmailSentToPatient={isEmailSentToPatient}
                    isNoteAdded={isNoteAdded}
                    selectedCardData={selectedCardData}
                    {...restProps}
                  />
                </TabPanel>
                <TabPanel id="home-email-tab-panel" value={selectedTab} index={2}>
                  <Email isEmailSentToPatient={isEmailSentToPatient} {...restProps} />
                </TabPanel>
                <TabPanel id="home-history-tab-panel" value={selectedTab} index={3}>
                  <History selectedPatientInfo={selectedPatientInfo} {...restProps} />
                </TabPanel>
                <TabPanel id="home-uploads-tab-panel" value={selectedTab} index={4}>
                  <div className="patient-chart-container flex flex-fill m-t-1">
                    <ControlledUploads data={{ patientUploads }} />
                  </div>
                </TabPanel>
              </>
            )
          }
        </div>
        {denyAndEmailOpen ? (
          <DenyAndEmail
            routePath={routePath}
            callStarted={callStarted}
            GetEmailTemplate={GetEmailTemplate}
            GetEmailTemplateFromSalesforce={GetEmailTemplateFromSalesforce}
            GetSubjectAndMailFromSalesforce={GetSubjectAndMailFromSalesforce}
            GetDenialReasons={GetDenialReasons}
            selectedCardData={selectedCardData}
            emailTemplate={emailTemplate}
            emailTemplatesV2={restProps.emailTemplatesV2}
            emailTemplateValue={restProps.emailTemplateValue}
            emailMessage={restProps.emailMessage}
            subjectLine={restProps.subjectLine}
            SetDenialAndSendValue={restProps.SetDenialAndSendValue}
            denialReasonValue={restProps.denialReasonValue}
            denialReason={restProps.denialReason}
            denialReasonText={restProps.denialReasonText}
            GetSubjectAndMail={restProps.GetSubjectAndMail}
            DenialAndEmail={restProps.DenialAndEmail}
            handleRouteChange={handleRouteChange}
            HandleGlobalValueChange={restProps.HandleGlobalValueChange}
            productInfo={restProps.productInfo}
            ClearEmailAndDenyData={restProps.ClearEmailAndDenyData}
            openDenyAndEmail={denyAndEmailOpen}
            isModalAlertOpen={restProps.isModalAlertOpen}
            SetModalAlertOpen={restProps.SetModalAlertOpen}
            closeOpenDenyAndEmail={(_) =>
              restProps.HandleGlobalValueChange({
                value: false,
                type: 'commonModal',
                name: 'denyAndEmailOpen',
              })
            }
          />
        ) : null}
        {approveAndSendEmailOpen ? (
          <ApproveAndSendEmail
            routePath={routePath}
            doseSpotData={doseSpotData}
            callStarted={callStarted}
            ApproveAndMailSubmit={ApproveAndMailSubmit}
            openapproveAndSendEmail={approveAndSendEmailOpen}
            selectedCardData={selectedCardData}
            GetEmailTemplate={GetEmailTemplate}
            GetEmailTemplateFromSalesforce={GetEmailTemplateFromSalesforce}
            GetSubjectAndMailFromSalesforce={GetSubjectAndMailFromSalesforce}
            productInfo={restProps.productInfo}
            productList={restProps.productList}
            handleRouteChange={handleRouteChange}
            approveAndMailData={approveAndMailData}
            emailTemplate={emailTemplate}
            emailTemplatesV2={restProps.emailTemplatesV2}
            SetDenialAndSendValue={restProps.SetDenialAndSendValue}
            GetSubjectAndMail={restProps.GetSubjectAndMail}
            emailTemplateValue={restProps.emailTemplateValue}
            emailMessage={restProps.emailMessage}
            subjectLine={restProps.subjectLine}
            SetApproveAndMailMainData={restProps.SetApproveAndMailMainData}
            SetApproveAndMailData={restProps.SetApproveAndMailData}
            approveAndMailPin={restProps.approveAndMailPin}
            HandleGlobalValueChange={restProps.HandleGlobalValueChange}
            GetApproveAndEmailPrepInfo={GetApproveAndEmailPrepInfo}
            GetOrderAndPrescriberFlags={restProps.GetOrderAndPrescriberFlags}
            orderAndPrescriberFlag={restProps.orderAndPrescriberFlag}
            approvalOrderFlagValue={restProps.approvalOrderFlagValue}
            approvalPrescriberFlagValue={restProps.approvalPrescriberFlagValue}
            OnApproveAndMailClick={restProps.OnApproveAndMailClick}
            approvalPinError={restProps.approvalPinError}
            ResetApproveAndMailData={restProps.ResetApproveAndMailData}
            isModalAlertOpen={restProps.isModalAlertOpen}
            SetModalAlertOpen={restProps.SetModalAlertOpen}
            getCmnPdfData={getCmnPdfData}
            patientInfo={selectedPatientInfo}
            consultInfo={restProps.consultQuestion}
            formField={restProps.cmnTemplateFormField}
            setFormField={restProps.SetCmnTemplateFormField}
            notes={{
              medicalOrderNotes: restProps.medicalOrderNotes
            }}
            history={{
              ...restProps.historyAPI,
              data: restProps.historyData,
            }}
            closeOpenDenyAndEmail={(_) =>
              restProps.HandleGlobalValueChange({
                value: false,
                type: 'commonModal',
                name: 'approveAndSendEmailOpen',
              })
            }
            action={{
              addDosespotPatientPrescription: restProps.DosespotGetPatientPrescriptionsByOrderRequest,
              resetDoseSpot: restProps.ResetDoseSpot,
            }}
          />
        ) : null}
        {addNoteOpen ? (
          <AddNote
            routePath={routePath}
            HandleGlobalValueChange={restProps.HandleGlobalValueChange}
            isNoteAdded={isNoteAdded}
            selectedCardData={selectedCardData}
            productInfo={restProps.productInfo}
            orderNoteText={restProps.orderNoteText}
            addPatientNote={restProps.addPatientNote}
            SetAddNoteValue={restProps.SetAddNoteValue}
            AddNote={restProps.AddNote}
            handleRouteChange={handleRouteChange}
            ClearAddNoteData={restProps.ClearAddNoteData}
            openAddNote={addNoteOpen}
            isModalAlertOpen={restProps.isModalAlertOpen}
            SetModalAlertOpen={restProps.SetModalAlertOpen}
            closeOpenAddNote={(_) => 
              restProps.HandleGlobalValueChange({
                value: false,
                type: 'commonModal',
                name: 'addNoteOpen',
              })
            }
          />
        ) : null}
          {addSoapNoteOpen ? (
          <AddSoapNote
            routePath={routePath}
            HandleGlobalValueChange={restProps.HandleGlobalValueChange}
            isNoteAdded={isNoteAdded}
            selectedCardData={selectedCardData}
            productInfo={restProps.productInfo}
            orderNoteText={restProps.orderNoteText}
            addPatientNote={restProps.addPatientNote}
            SetAddSoapNoteValue={restProps.SetAddSoapNoteValue}
            AddSoapNote={restProps.AddSoapNote}
            handleRouteChange={handleRouteChange}
            ClearAddNoteData={restProps.ClearAddNoteData}
            openSoapNote={addSoapNoteOpen}
            isModalAlertOpen={restProps.isModalAlertOpen}
            SetModalAlertOpen={restProps.SetModalAlertOpen}
            closeOpenAddNote={(_) =>
              restProps.HandleGlobalValueChange({
                value: false,
                type: 'commonModal',
                name: 'addSoapNoteOpen',
              })}
            enableOnSoapSuccess={this.enableOnSoapSuccess}
            selectedPatientInfo={selectedPatientInfo}
            soapNoteTemplates={soapNoteTemplates}
            action={{
              setSoapTemplate,
              getSoapTemplates,
              setSoapNote: restProps.SetAddSoapNoteValue,
            }}
          />
        ) : null}
        {sendOrderToCSOpen ? (
          <SendOrderToCSComponent
            routePath={routePath}
            callStarted={callStarted}
            selectedCardData={selectedCardData}
            productInfo={restProps.productInfo}
            GetSendOrderToCSReasons={GetSendOrderToCSReasons}
            sendOrderToCSReason={sendOrderToCSReason}
            SendOrderToCS={SendOrderToCS}
            sendOrderToCSReasons={sendOrderToCSReasons}
            sendOrderToCSNote={sendOrderToCSNote}
            HandleGlobalValueChange={restProps.HandleGlobalValueChange}
            handleRouteChange={handleRouteChange}
            SetSendOrderToCSData={SetSendOrderToCSData}
            ResetSendOrderToCS={ResetSendOrderToCS}
            openSendOrderToCS={sendOrderToCSOpen}
            isModalAlertOpen={restProps.isModalAlertOpen}
            SetModalAlertOpen={restProps.SetModalAlertOpen}
            closeOpenSendOrderToCS={(_) =>
              restProps.HandleGlobalValueChange({
                value: false,
                type: 'commonModal',
                name: 'sendOrderToCSOpen',
              })
            }
          />
        ) : null}
        {callPatientOpen ? (
          <CallPatient
            selectedCardData={selectedCardData}
            handleRouteChange={handleRouteChange}
            HandleGlobalValueChange={restProps.HandleGlobalValueChange}
            productInfo={restProps.productInfo}
            GetCallPatientDetails={GetCallPatientDetails}
            callPatientDetails={callPatientDetails}
            CallToPatient={CallToPatient}
            CallToPatientPhys={CallToPatientPhys}
            SetCallSummary={SetCallSummary}
            InsertCallSummary={InsertCallSummary}
            OrderCallSummaryReasons={OrderCallSummaryReasons}
            callToPatientStatus={callToPatientStatus}
            SetCallPatientDetails={SetCallPatientDetails}
            ResetCallPatientDetails={ResetCallPatientDetails}
            openCallPatient={callPatientOpen}
            isModalAlertOpen={restProps.isModalAlertOpen}
            SetModalAlertOpen={restProps.SetModalAlertOpen}
            SetModalTwilioAlertOpen={SetModalTwilioAlertOpen}
            isModalTwilioAlertOpen={isModalTwilioAlertOpen}
            historyView={restProps.historyView}
            closeOpenCallPatient={(_) =>
              restProps.HandleGlobalValueChange({
                value: false,
                type: 'commonModal',
                name: 'callPatientOpen',
              })
            }
            callSummary={restProps.callSummary}
            GetMedicalOrderNotes={restProps.GetMedicalOrderNotes}
            GetMedicalPatientNotes={restProps.GetMedicalPatientNotes}
            GetOrderNotes={restProps.GetOrderNotes}
            GetPatientNotes={restProps.GetPatientNotes}
          />
        ) : null}
        {openTextPatient ? (
          <TextPatient
            selectedCardData={selectedCardData}
            productInfo={restProps.productInfo}
            GetTextPatientTemplates={GetTextPatientTemplates}
            textMessageTemplateValue={textMessageTemplateValue}
            textmessageTemplateData={textmessageTemplateData}
            messageValue={restProps.messageValue}
            HandleGlobalValueChange={restProps.HandleGlobalValueChange}
            ResetTextPatientDetails={ResetTextPatientDetails}
            TextPatient={restProps.TextPatient}
            openTextPatient={openTextPatient}
            isModalAlertOpen={restProps.isModalAlertOpen}
            SetModalAlertOpen={restProps.SetModalAlertOpen}
            isModalTwilioAlertOpen={isModalTwilioAlertOpen}
            closeTextPatient={(_) =>
              restProps.HandleGlobalValueChange({
                value: false,
                type: 'commonModal',
                name: 'openTextPatient',
              })
            }
          />
        ) : null}
        {emailPatientOpen ? (
          <EmailPatient
            HandleGlobalValueChange={restProps.HandleGlobalValueChange}
            selectedCardData={selectedCardData}
            productInfo={restProps.productInfo}
            isEmailSentToPatient={isEmailSentToPatient}
            SetDenialAndSendValue={restProps.SetDenialAndSendValue}
            GetEmailTemplate={GetEmailTemplate}
            GetEmailTemplateFromSalesforce={GetEmailTemplateFromSalesforce}
            GetSubjectAndMailFromSalesforce={GetSubjectAndMailFromSalesforce}
            emailTemplate={emailTemplate}
            emailTemplatesV2={restProps.emailTemplatesV2}
            GetSubjectAndMail={restProps.GetSubjectAndMail}
            emailTemplateValue={restProps.emailTemplateValue}
            emailMessage={restProps.emailMessage}
            subjectLine={restProps.subjectLine}
            openEmailPatient={emailPatientOpen}
            isModalAlertOpen={restProps.isModalAlertOpen}
            SetModalAlertOpen={restProps.SetModalAlertOpen}
            EmailPatientDetails={EmailPatientDetails}
            ClearEmailPatientData={restProps.ClearEmailPatientData}
            closeOpenEmailPatient={(_) =>
              restProps.HandleGlobalValueChange({
                value: false,
                type: 'commonModal',
                name: 'emailPatientOpen',
              })
            }
          />
        ) : null}
        {isDoseSpotErrorModalOpen ? (
          <DoseSpotErrorModal
            isDoseSpotErrorModalOpen={isDoseSpotErrorModalOpen}
            closeModal={this.closeDoseSpotErrorModal}
          />
        ) : null}
      </div>
    );
  }
}

export default withStyles(MainPageStyle)(
  withMediaQuery("(max-width:1400px)")(MainPage)
);

class TabPanel extends React.Component {
  render() {
    const { value, index, children } = this.props;
    const style = value === index
      ? { display: "flex", flex: 1, minHeight: 320, zIndex: 0 }
      : { display: "none" };
    return (
      <div className="tab-panel" style={style}>
        {children}
      </div>
    );
  }
}
